import AvatarDoctor from "@shared/assets/icons/doctor.png";
import AvatarNurse from "@shared/assets/user-types/nurse.png";
import AvatarOrganization from "@shared/assets/user-types/organization.png";
import AvatarPatient from "@shared/assets/user-types/patient.png";

import {
  FaHeadset,
  FaQuestion,
  FaUser,
  FaUserDoctor,
  FaUserGear,
  FaUserNurse,
  FaUserTie,
} from "react-icons/fa6";
import { TbBuildingHospital } from "react-icons/tb";

export const UserType = {
  patient: "Patient",
  doctor: "Docteur",
  assistant: "Infirmier",
  midwife: "Sage-femme",
  organization: "Organisation",
};

export const UserTypeIcon = {
  patient: FaUser,
  doctor: FaUserDoctor,
  assistant: FaUserNurse,
  midwife: FaUserNurse,
  organization: TbBuildingHospital,
  dispatchOperator: FaHeadset,
  dispatchManager: FaUserTie,
  admin: FaUserGear,
  DEFAULT: FaQuestion,
};

const Avatar = ({ avatar }: { avatar: string }) => {
  return (
    <img
      src={avatar}
      className="rounded-full bg-primary p-0 size-16   text-white shrink-0"
    />
  );
};

export const UserTypeAvatar = {
  patient: () => <Avatar avatar={AvatarPatient} />,
  doctor: () => <Avatar avatar={AvatarDoctor} />,
  assistant: () => <Avatar avatar={AvatarNurse} />,
  midwife: () => <Avatar avatar={AvatarNurse} />,
  organization: () => <Avatar avatar={AvatarOrganization} />,
  DEFAULT: () => <Avatar avatar={AvatarPatient} />,
};
